var chunkToChildrenMap = {
	"1063": [
		6533,
		7342,
		5166,
		6091,
		1298,
		3509,
		4202,
		9616,
		3986,
		9562,
		6084,
		848,
		240,
		6278,
		2720,
		3046,
		8303
	],
	"3739": [
		6533,
		7342,
		5166,
		6091,
		1298,
		3509,
		4202,
		9616,
		3986,
		9562,
		6084,
		848,
		240,
		6278,
		2720,
		3046,
		8303
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));